/**
 * Featured Collections Section with Splide
 * - Slider enabled on mobile (always)
 * - Slider can be toggled on/off for desktop via settings
 * - Grid layout on desktop when slider is disabled
 */

window.initFeaturedCollectionsSlider = function (container) {
  const slider = container.querySelector('.featured-collections__slider');

  if (!slider || typeof Splide === 'undefined') return null;

  const enableSliderDesktop = container.dataset.enableSliderDesktop === 'true';
  const collectionsPerPage = parseInt(container.dataset.collectionsPerPage || '4');
  let splideInstance = null;

  const shouldEnableSlider = () => {
    const isTabletOrMobile = window.innerWidth < 1100;
    return isTabletOrMobile || enableSliderDesktop;
  };

  // Splide sets role="group" on <li> slides, which violates the ARIA-in-HTML spec
  // (<li> only permits listitem, menuitem, option, none/presentation, etc.).
  // Fix: override to role="listitem" after every mount/remount.
  function fixSlideRoles(splide) {
    splide.Components.Slides.get().forEach(function (slideObj) {
      slideObj.slide.setAttribute('role', 'listitem');
    });
  }

  // Initialize slider (always mounted, but may be disabled)
  splideInstance = window.SplideUtils.initSplideWithControls(
    slider,
    container,
    {
      perPage: collectionsPerPage,
      perMove: 1,
      gap: '24px',
      arrows: false,
      pagination: false,
      rewind: true,
      drag: shouldEnableSlider(),
      breakpoints: {
        1099: {
          perPage: 3,
          gap: '24px',
          drag: true, // Always enabled on mobile
        },
        767: {
          perPage: 2,
          gap: '16px',
          drag: true, // Always enabled on mobile
        },
        550: {
          perPage: 1,
          gap: '16px',
          padding: { right: '25%' },
          drag: true, // Always enabled on mobile
        }
      },
      i18n: {
        prev: 'Previous collection',
        next: 'Next collection',
        first: 'Go to first collection',
        last: 'Go to last collection',
        slideX: 'Go to collection %s',
        pageX: 'Go to page %s',
        play: 'Start autoplay',
        pause: 'Pause autoplay',
        carousel: 'Featured collections carousel',
        select: 'Select a collection to view',
        slide: 'collection',
        slideLabel: '%s of %s',
      }
    },
    {
      customArrows: true,
      scrollbar: true,
      tabindex: true
    }
  );

  // Apply role fix now (initial mount already ran inside initSplideWithControls)
  // and re-apply on every future remount triggered by refresh().
  if (splideInstance) {
    fixSlideRoles(splideInstance);
    splideInstance.on('mounted', function () { fixSlideRoles(splideInstance); });
  }

  // Update slider state based on conditions
  const updateSlider = () => {
    if (!splideInstance) return;

    const shouldEnable = shouldEnableSlider();

    if (shouldEnable) {
      container.classList.add('slider-active');
      splideInstance.options.drag = true;
      splideInstance.refresh();
    } else {
      container.classList.remove('slider-active');
      splideInstance.options.drag = false;
      splideInstance.go(0);
      splideInstance.refresh();
    }
  };

  // Initial setup
  updateSlider();

  // Handle resize
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateSlider, 250);
  };
  window.addEventListener('resize', handleResize);

  // Return destroy function for cleanup
  return {
    destroy: () => {
      window.removeEventListener('resize', handleResize);
      if (splideInstance) splideInstance.destroy();
    }
  };
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('[id^="FeaturedCollections-"]');
  containers.forEach(container => {
    container.sliderInstance = window.initFeaturedCollectionsSlider(container);
  });
});

// Setup theme editor events
if (typeof window.SplideUtils !== 'undefined') {
  window.SplideUtils.setupThemeEditorEvents(
    'FeaturedCollections-',
    '.featured-collections__slider',
    (sectionElement) => {
      const container = sectionElement.querySelector('[id^="FeaturedCollections-"]');
      if (container) {
        if (container.sliderInstance?.destroy) {
          container.sliderInstance.destroy();
        }
        container.sliderInstance = window.initFeaturedCollectionsSlider(container);
      }
    }
  );
}
